export default __webpack_public_path__ + "static/media/idea-web-3.bf10e955.png";